<template>
  <div v-if="!isMultiLang" class="form-group">
    <label>{{ label }}</label>
    <input
      v-if="type === 'text'"
      :value="value"
      type="text"
      class="form-control"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    />
    <textarea
      v-else
      :value="value"
      class="form-control"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    ></textarea>
  </div>
  <div v-else class="form-group">
    <label>{{ label }}</label>
    <ul class="nav nav-tabs">
      <li v-for="iso in isos" :key="iso" class="nav-item">
        <a
          class="nav-link" :class="{ active: activeIso === iso }"
          href="#"
          @click.prevent="activeIso = iso"
        >
          <img :src="flagUrl(iso)" style="width:18px;border-radius:9px;margin-top:-4px;" />
          {{ iso.toUpperCase() }}
        </a>
      </li>
      <li v-if="activeIso !== primaryIso" class="nav-item pull-right">
        <a
          class="nav-link" href="#"
          @click.prevent="aiTranslate"
          style="background-color:#1ab394;color:#fff;font-weight:400;border-bottom:none;cursor:pointer;"
        >
          Mit KI übersetzen
        </a>
      </li>
    </ul>
    <div class="tab-content" style="border:1px solid #ddd;border-top:none;padding:10px;">
      <div v-for="iso in isos" :key="iso" v-show="activeIso === iso" style="position:relative;">
        <input
          v-if="type === 'text'"
          :value="localValue(iso)" type="text" class="form-control"
          :disabled="disabled"
          @input="onInput(iso, $event.target.value)"
        />
        <textarea
          v-else
          :value="localValue(iso)" class="form-control"
          :disabled="disabled"
          @input="onInput(iso, $event.target.value)"
        ></textarea>
        <div
          v-show="translatingIso === iso"
          style="position:absolute;inset:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;color:#fff;border-radius:4px;z-index:10;"
        >
          <span>Wird übersetzt...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { aiTranslateText } from './services/translationApi'

export default {
  name: 'TextTranslated',
  props: {
    value:       { type: String, default: '' },
    fieldPath:   { type: String, required: true },
    label:       { type: String, default: '' },
    type:        { type: String, default: 'text' },
    disabled:    { type: Boolean, default: false },
    isos:        { type: Array,  default: () => [] },
    languages:   { type: Object, default: () => ({}) },
    flagCdnUrl:  { type: String, default: '/images/flags/' },
    translations:{ type: Object, default: () => ({}) },
  },
  data() {
    return {
      activeIso: this.isos[0] || 'de',
      translatingIso: null,
    }
  },
  watch: {
    isos(val) {
      if (!val.includes(this.activeIso)) {
        this.activeIso = val[0] || 'de'
      }
    },
  },
  computed: {
    primaryIso() { return this.isos[0] || 'de' },
    isMultiLang() { return this.isos.length > 1 },
  },
  methods: {
    localValue(iso) {
      if (iso === this.primaryIso) return this.value
      return this.translations[this.fieldPath]?.[iso] || ''
    },
    onInput(iso, val) {
      if (iso === this.primaryIso) {
        this.$emit('input', val)
      } else {
        this.$emit('translation-updated', { fieldPath: this.fieldPath, iso, value: val })
      }
    },
    async aiTranslate() {
      const targetIso = this.activeIso
      if (targetIso === this.primaryIso || this.translatingIso) return
      this.translatingIso = targetIso
      try {
        const text = await aiTranslateText(this.value, this.primaryIso, targetIso)
        this.$emit('translation-updated', { fieldPath: this.fieldPath, iso: targetIso, value: text })
      } catch {
        alert('Fehler bei der KI-Übersetzung')
      } finally {
        this.translatingIso = null
      }
    },
    flagUrl(iso) {
      const code = iso === 'en' ? 'gb' : iso
      return this.flagCdnUrl + code + '.svg'
    },
  },
}
</script>

<style scoped>
.nav-tabs .nav-link {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ddd;
}
.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.nav-tabs .nav-link.active {
  font-weight: 600;
  background: #ddd;
  color: #6a6a6a;
}
</style>